import { render, staticRenderFns } from "./AppIcons.vue?vue&type=template&id=9565230a&scoped=true"
import script from "./AppIcons.vue?vue&type=script&lang=js"
export * from "./AppIcons.vue?vue&type=script&lang=js"
import style0 from "./AppIcons.vue?vue&type=style&index=0&id=9565230a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9565230a",
  null
  
)

export default component.exports